import { Route, Routes } from 'react-router-dom';
import { BookReportForm } from './BookReportForm';
import { BookReportView } from './BookReportView';
import { BookReportListAll } from './BookReportListAll';

export const BookReportPage = ()=>{
    return (
        <div className="bookReportPage">
        <Routes>
            <Route path="/" element={ <BookReportListAll/> } />
            <Route path="/create/:isbn" element={ <BookReportForm/> } />
            <Route path="/edit/:id" element={ <BookReportForm/> } />
            {/* <Route path="/view/:id" element={ <BookReportList /> } /> 
            이렇게 하려면 ?id=bookreport.id
            */}
            <Route path="/view/:id" element={ <BookReportView /> } />
        </Routes>
        </div>
    );
}